export default __webpack_public_path__ + "static/media/gallery5.0934e8e4.jpg";